import { render, staticRenderFns } from "./AdminAllTickets.vue?vue&type=template&id=55cbbc16&scoped=true&"
import script from "./AdminAllTickets.vue?vue&type=script&lang=js&"
export * from "./AdminAllTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbbc16",
  null
  
)

export default component.exports